import moment from 'moment'

import {
  CostCenterAssignment,
  FormattedAssignment,
} from 'modules/finance/lib/costCenterAssignments'

interface Props {
  currentAssignments: FormattedAssignment[]
  employeeAssignments: CostCenterAssignment[]
  isCurrentActive: boolean
  startDate?: string
}

export const canBeMarkedAsActive = ({
  currentAssignments,
  employeeAssignments,
  isCurrentActive,
  startDate,
}: Props) => {
  const startDateMoment = moment(startDate)

  const hasNotAssignments = employeeAssignments.length <= 1

  const hasNotPreviousAssignment = employeeAssignments
    .filter((assignment) => assignment.id !== Number(currentAssignments[0]?.id))
    .every((assignment) => {
      return startDateMoment.isAfter(moment(assignment.startDate), 'day')
    })

  return hasNotAssignments || hasNotPreviousAssignment || isCurrentActive
}
